export default __webpack_public_path__ + "src/assets/new.1df245ce82dd21ce0f4f43256cfb8b5b.svg";